module.exports = __webpack_public_path__ + "static/media/PasswordChecker.df2f727f.svg";